import React, { useState } from 'react';

import { Button } from 'semantic-ui-react';

import { useSelector } from 'react-redux';

import ConfirmationPage from 'components/common/ConfirmationPage';
import { DismissibleMessage } from 'components/modules/utils/components';
import API from 'libs/api';
import { multiCaseGet } from 'libs/format';
import { selectUser } from 'selectors/user';

import './RequestPasswordReset.scss';

function RequestPasswordReset() {
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const user = useSelector(selectUser);
  const email = multiCaseGet(user, 'email', '');

  async function onSubmit() {
    if (!email) {
      setErrorMessage('Email address not found');
      return;
    }

    setLoading(true);
    setErrorMessage('');

    try {
      await API.sendPasswordResetEmail(email);
      setShowConfirmation(true);
    } catch (e) {
      setErrorMessage('Failed to send password reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="request-password-reset">
      {showConfirmation && (
        <ConfirmationPage
          icon="mail outline"
          iconColor="blue"
          subject="Check your email"
          content={
            <p>
              We just sent you a password reset link at <strong>{email}</strong>.
              <br />
              Please check your inbox and click on the link to reset your password.
            </p>
          }
        />
      )}

      {!showConfirmation && (
        <div className="content">
          <p>To change your password, we&apos;ll send you a secure link via email.</p>
          <Button
            className="action"
            type="button"
            onClick={onSubmit}
            loading={loading}
            disabled={loading || !email}
          >
            Send Password Reset Email
          </Button>

          {errorMessage && (
            <DismissibleMessage error initialVisible onDismiss={() => setErrorMessage('')}>
              {errorMessage}
            </DismissibleMessage>
          )}
        </div>
      )}
    </div>
  );
}

export default RequestPasswordReset;
